// eslint-disable-next-line import/no-unresolved
import PhotoSwipeLightbox from 'https://www.unpkg.com/photoswipe@5.2.7/dist/photoswipe-lightbox.esm.min.js?module'

const { viewportSize } = window.BAO.Utils

export class ProductPhotoSwipe extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['link']
  }

  connectedCallback () {
    super.connectedCallback()

    this.photoSwipeInstance = new PhotoSwipeLightbox({
      loop: true,
      showAnimationDuration: 500,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: this.secondaryZoomLevel,
      maxZoomLevel: 3,
      scaleMode: 'zoom',

      gallery: this.localName,
      children: this.els.link.selector,
      bgOpacity: 1,
      arrowPrev: false,
      arrowNext: false,
      zoom: false,
      close: false,
      counter: false,

      closeOnVerticalDrag: true,

      pswpModule: () => {
        return import(
          // eslint-disable-next-line import/no-unresolved
          'https://www.unpkg.com/photoswipe@5.2.7/dist/photoswipe.esm.min.js?module'
        )
      },
    })

    this.setupPhotoSwipeListeners()
    this.photoSwipeInstance.init()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'click', this.handleClick.bind(this))

    this.querySelectorAll(this.els.link.selector).forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault()
      })
    })
  }

  setupPhotoSwipeListeners () {
    this.photoSwipeInstance.on('uiRegister', () => {
      this.addPreviousButton()
      this.addNextButton()
      this.addCloseButton()
      this.addDots()
    })
  }

  addPreviousButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-prev',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-previous',
      ariaLabel: 'Previous',
      order: 1,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.prev()
      },
    })
  }

  addNextButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-next',
      className: 'pswp-Action_Arrow pswp-Action_Arrow-next',
      ariaLabel: 'Next',
      order: 3,
      isButton: true,
      html: this.arrowSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.next()
      },
    })
  }

  addCloseButton () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'custom-close',
      className: 'pswp-Action_Close',
      ariaLabel: 'Close',
      order: 2,
      isButton: true,
      html: this.closeSvg,
      onClick: () => {
        this.photoSwipeInstance.pswp.close()
      },
    })
  }

  addDots () {
    this.photoSwipeInstance.pswp.ui.registerElement({
      name: 'dots',
      className: 'pswp-Action_Dots',
      appendTo: 'wrapper',
      onInit: (element, pswp) => {
        const dotEls = []
        let dotEl
        let previousIndex = -1

        for (let i = 0; i < pswp.getNumItems(); i++) {
          dotEl = document.createElement('button')
          dotEl.type = 'button'
          dotEl.className = 'pswp-Action_Dot'
          dotEl.onclick = event => {
            pswp.goTo(dotEls.indexOf(event.target))
          }
          element.appendChild(dotEl)
          dotEls.push(dotEl)
        }

        pswp.on('change', () => {
          if (previousIndex >= 0) {
            dotEls[previousIndex].setAttribute('aria-current', 'false')
          }
          dotEls[pswp.currIndex].setAttribute('aria-current', 'true')
          previousIndex = pswp.currIndex
        })
      },
    })
  }

  handleClick (event) {
    if (event.target.matches('.pswp__img')) {
      const photoSwipeEl = event.target.closest('.pswp')
      if (!photoSwipeEl) return
      photoSwipeEl.setAttribute(
        'data-cursor',
        String(
          this.photoSwipeInstance?.pswp?.currSlide?.currZoomLevel === 2
            ? 'minify'
            : 'magnify',
        ),
      )
    }
  }

  get secondaryZoomLevel () {
    switch (viewportSize()) {
      case 'xs':
        return 0.5
      case 'sm':
        return 0.5
      default:
        return 1
    }
  }

  get arrowSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 14"><path fill="currentColor" fill-rule="evenodd" d="m14.992 7.107.328-.345-.328-.345L8.88 0l-.724.69 5.303 5.568H0v1h13.468l-5.311 5.576.724.69 6.112-6.417Z" clip-rule="evenodd"/></svg>`
  }

  get closeSvg () {
    return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="9.31 9.01 18.68 18.97" aria-hidden="true"><line x1="27.4868" y1="9.80936" x2="9.80915" y2="27.487" stroke="currentColor"/><line x1="9.80915" y1="9.51339" x2="27.4868" y2="27.1911" stroke="currentColor"/></svg>`
  }
}

if (!customElements.get('product-photoswipe')) {
  customElements.define('product-photoswipe', ProductPhotoSwipe)
}
